/* eslint-disable react/no-unescaped-entities */
import { useState } from "react";
import Reveal from "./Reveal";
import { LANDING } from "@/constants/testIds";

const FAQS = [
  {
    q: "Is there an extra cost for the tree planting?",
    a: "No. Every Utsah hamper automatically includes The Green Gift Initiative. It's part of what makes an Utsah gift, an Utsah gift.",
  },
  {
    q: "How do I know the trees are actually planted?",
    a: "Every tree is planted through Grow-Trees, an independently verified reforestation partner. You'll receive certificates in every hamper, and detailed reports for bulk orders.",
  },
  {
    q: "Can I choose the specific project we contribute to?",
    a: "Yes. During your order, you'll be shown all our active projects across India. Pick the region or cause that resonates with your team.",
  },
  {
    q: "Do we get an ESG or CSR report for our contribution?",
    a: "Absolutely. For bulk corporate orders, we provide a consolidated impact report suitable for your ESG, CSR, and internal communications.",
  },
  {
    q: "Can our logo appear on the certificate?",
    a: "For bulk orders (100+ hampers), yes — we can co-brand the certificate with your company name and, optionally, your logo.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex((cur) => (cur === i ? null : i));

  return (
    <section className="section faq">
      <div className="section-inner">
        <div className="faq-grid">
          <div>
            <Reveal className="eyebrow">Frequently Asked</Reveal>
            <Reveal as="h2" delay={1} className="section-headline">
              Answers, before <em>you ask.</em>
            </Reveal>
            <Reveal as="p" delay={2} className="section-sub" style={{ marginTop: 20 }}>
              Thoughtful gifting comes with thoughtful questions. Here's everything about how the Green Gift Initiative works.
            </Reveal>
          </div>
          <div className="faq-list">
            {FAQS.map((item, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={item.q}
                  className={`faq-item ${open ? "open" : ""}`.trim()}
                  data-testid={LANDING.faqItem(i + 1)}
                >
                  <button
                    className="faq-q"
                    onClick={() => toggle(i)}
                    aria-expanded={open}
                    data-testid={LANDING.faqToggle(i + 1)}
                    style={{
                      width: "100%",
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                      textAlign: "left",
                      fontFamily: "inherit",
                    }}
                  >
                    <h3 className="faq-q-text">{item.q}</h3>
                    <div className="faq-q-icon">+</div>
                  </button>
                  {open && <div className="faq-a">{item.a}</div>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
